<template>
    <div class="sw">
      <section id="s1">
        <div class="s1-container">
          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td1"></div>
              <div class="timeline-time">2013</div>
            </div>
            <div class="timeline-story">
              <p>I got my first personal laptop, running Windows XP. Rigged up a basic 3G connection to the Internet and started poking around to see how things work.</p>
              <p>Learned basic HTML and CSS by examining existing websites on the Web. Made my first publicly avalible website using a constructor and a free hosting.</p>
              <p>Got interested in scripting for games and learning C++ via tutorials on YouTube.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td2"></div>
              <div class="timeline-time">2014</div>
            </div>
            <div class="timeline-story">
              <p>Started learning PHP and JavaScript. Made another website using customized templates for Joomla CMS.</p>
              <p>First introduction to Linux (Ubuntu Desktop) and network infrastructure.</p>
              <p>Started looking into wireless security and access-control systems.</p>
              <p>Performed my first successful authentication bypass for Windows Vista using a modified Linux ISO.</p>
              <p>Started helping people with their computer-related issues and became a replacement IT support for my school, rigging up a couple of school PCs with small Wi-Fi routers to give me free Internet access in the process.</p>
              <p>Got a new laptop on Windows 8. Began a deep-dive into computer hardware.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td3"></div>
              <div class="timeline-time">2015</div>
            </div>
            <div class="timeline-story">
              <p>Wrote a couple of SMS-based remote access scripts for android phones.</p>
              <p>Started learning Linux for servers and Bash scripting, hosted a couple of game servers for my friends, aggregated into virtual LAN networks.</p>
              <p>Began a deep-dive into android applications and cryptography. Made a copule of reskins and mods for existing applications.</p>
              <p>Learned NodeJS and WebSockets, started working for a professional CS:GO team, writing Twitch integrations and other streaming utilities.</p>
              <p>Started learning Python as a quick/PoC alternative to small scripts written in NodeJS.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td4"></div>
              <div class="timeline-time">2016</div>
            </div>
            <div class="timeline-story">
              <p>Started learning Pascal in school as a part of the education plan.</p>
              <p>First time finalist of a city-wide programming contest.</p>
              <p>Set up my laptop to dual-boot into Kali Linux and often used it as a primary system for day-to-day tasks.</p>
              <p>Wrote a fisrt authentication bypass exploit for a nation-wide transport system. Followed by a PoC for arbitrary mobile phone tracking within it.</p>
              <p>Obtained a set of RFID-controlled turnstiles, started exploring low-level communication protocols, embedded electronics and hardware design.</p>
              <p>Started learning SQL and wrote an inventory tracking system for event company I volunteered for.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td5"></div>
              <div class="timeline-time">2017</div>
            </div>
            <div class="timeline-story">
              <p>School graduation project: Modular mesh-based home automation solution using Omega SoCs.</p>
              <p>First time quater-finalist of a nation-wide programming contest.</p>
              <p>Made a couple of websites for local businesses.</p>
              <p>Built my first Linux Server runng CentOS 7, used it as a family NAS with access over DDNS. Began hosting CI/CD solutions for A Little Bit Different Arts, wrote SVN/Git helpers and notifiers for Discord. Set up a semi-automatic render farm for Pixar render engine.</p>
              <p>Started learning Natural Language Processing algorithms and AI.</p>
              <p>Set up a homelab with Multi-WAN uplinks and load balancers. Built my first server room.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td6"></div>
              <div class="timeline-time">2018</div>
            </div>
            <div class="timeline-story">
              <p>First public contributions to open-source repos. Full collaborative code refactoring.</p>
              <p>Started learning GO, C#, VBA and TypeScript for personal and university projects.</p>
              <p>Developed a set of utilities and live-render apps for livestreaming at conventions.</p>
              <p>Quater-finalist in a Moscow Programming Contest (RuCode) 2018.</p>
              <p>First time finalist in an international programming contest (International Collegiate Programming Contest 2018 - First Stage Award Winner).</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td7"></div>
              <div class="timeline-time">2019</div>
            </div>
            <div class="timeline-story">
              <p>University project: Social media scraping for creating detailed reports and predictive model construction.</p>
              <p>Dove deeper into cyber-security.</p>
              <p>Started learning enterprise networking, set up a couple of servers and APs for my university.</p>
              <p>Got invited to participate in Google FooBar.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td8"></div>
              <div class="timeline-time">2020</div>
            </div>
            <div class="timeline-story">
              <p>University project: Datacenter-ready automatically controlled and scalable system for verifying crypto transactions (best profit crypto mining).</p>
              <p>Held a series of conferences and talks centered around cyber-security.</p>
              <p>First time participation in CTFs as a team of 3. First time solo participation in CTFs.</p>
              <p>Started learning Java and Kotlin for my Yandex Internship.</p>
            </div>
          </div>

          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td9"></div>
              <div class="timeline-time">2021</div>
            </div>
            <div class="timeline-story">
              <p>Graduated MSUPE University with a Computer Science degree. Graduation project: Programmable modular control surface for live broadcast setups.</p>
              <p>Developed a lot of procedural graphics, game servers, chatbots, moderation tools and analytics suites for a couple of streamers on Twitch.</p>
              <p>Got invited (again) to participate in Google FooBar. Stopped at Level 3 after getting invites for friends.</p>
            </div>
          </div>
          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td10"></div>
              <div class="timeline-time">2022-2023</div>
            </div>
            <div class="timeline-story">
              <p>Continued on expanding the capabilities of previously written software for Twitch. First experience with using 3D frameworks for web.</p>
              <p>Started reverse-engineering malware and stealers. Created a small campaign, focused around taking down malware comamnd-and-control servers. First YARA contributions</p>
              <p>Started exploring Vue3 for personal projects.</p>
              <p>Developed a high-RPS backend for a large nation-wide system.</p>
              <p>Hit Top-5% on CodeWars worldwide.</p>
            </div>
          </div>
          <div class="timeline-container">
            <div class="timeline-timeport">
              <div class="timeline-dot" id="td12"></div>
              <div class="timeline-time">2024</div>
            </div>
            <div class="timeline-story">
              <p>Hit Top-100 US teams on a global CTF leaderboard as a solo player.</p>
              <p>Started the development on a set of personal websites using my own infrastructure.</p>
            </div>
          </div>

        </div>
        <canvas id="timebg" width="0" height="0"></canvas>
      </section>
      <section id="s2">
        <div class="s2-container">
          <ProjectList :tags="local_tags"/>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import { laginter, remap } from '@/utils/magic.js'
  import ProjectList from '@/components/ProjectList.vue'

  function updateUi() {
    const sec1_e = document.getElementById('s1')
    const bg_e = document.getElementById('timebg')
    bg_e.setAttribute('width', Number(window.getComputedStyle(sec1_e).width.replaceAll("px", "")))
    bg_e.setAttribute('height', Number(window.getComputedStyle(sec1_e).height.replaceAll("px", "")))
    redraw()
  }

  function redraw(e) {
    const sec1_e = document.getElementById('s1')
    const bg_e = document.getElementById('timebg')
    const ctx = bg_e.getContext("2d");
    const nav_coords = document.getElementsByTagName('nav')[0].getBoundingClientRect()
    ctx.fillStyle = "rgb(15, 15, 15)";
    ctx.fillRect(0, 0, bg_e.clientWidth, bg_e.clientHeight);
    ctx.strokeStyle = "rgba(200, 200, 255, 0.2)";
    ctx.lineWidth  = 5;
    const window_y = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
    const view_center = [
      window.innerWidth/2,
      window.innerHeight/2+window_y-nav_coords.height
    ]

    const bg_end = [
      window.innerWidth/2,
      bg_e.clientHeight+nav_coords.height
    ]
    const draw_perc = remap(view_center[1], nav_coords.height, bg_end[1], 0, 1)

    const dotpos = []
    
    for (const dot of document.getElementsByClassName('timeline-dot')) {
      let dot_pos_data = dot.getBoundingClientRect()
      let dot_center = [
        dot_pos_data.x+dot_pos_data.width/2,
        dot_pos_data.y+dot_pos_data.height/2+window_y-nav_coords.height,
        remap(dot_pos_data.y+dot_pos_data.height/2+window_y, nav_coords.height, bg_end[1], 0, 1)
      ]
      dotpos.push(dot_center)
      if(dot_center[2]<=draw_perc){
        dot.style.opacity = 1
      } else {
        dot.style.opacity = 0
      }
    }
    ctx.beginPath()
    ctx.moveTo(bg_e.clientWidth/2, 0)
    for (let step = 0; step < draw_perc; step+=0.0001) {
      ctx.lineTo(
        laginter(step, dotpos.map(e=>[e[2], e[0]])),
        laginter(step, dotpos.map(e=>[e[2], e[1]])),
      )
    }
    ctx.stroke()
    ctx.fillStyle = "rgba(100, 148, 255, 0.7)";
    ctx.beginPath()
    ctx.arc(
        laginter(draw_perc, dotpos.map(e=>[e[2], e[0]])),
        laginter(draw_perc, dotpos.map(e=>[e[2], e[1]])),
        8,
        0,
        2 * Math.PI
      );
    ctx.fill()
  }

  export default {
    name: 'SoftwareView',
    components: {ProjectList},
    setup(props) {
      const scr = (to_id) => {document.getElementById(to_id).scrollIntoView({behavior: 'smooth'})}
      const local_tags = ['Software']
      return {scr, local_tags}
    },
    mounted() {
      window.addEventListener('resize', updateUi)
      window.addEventListener('scroll', redraw)
      updateUi()
    },
    unmounted() {
      window.removeEventListener('resize', updateUi)
      window.removeEventListener('scroll', redraw)
    },
    methods: {
    },
  }
  </script>
  
<style>

#timebg{
  position: absolute;
  z-index: -1;
}

#s1, #s2{
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.s1-container{
  max-width: 65em;
}

.s2-container{
  max-width: 75vw;
}

.timeline-container{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 6em;
  margin-bottom: 6em;
}

.timeline-container:nth-child(even){
  flex-direction: row-reverse;
}

.timeline-container:nth-child(1){
  margin-top: 12rem;
}
.timeline-container:last-child{
  margin-bottom: 12rem;
}

.timeline-dot{
  width: 2em;
  height: 2em;
  background: white;
  opacity: 0;
  transition: opacity 300ms cubic-bezier(0.78, 1.99, 0.41,-1.51);
  filter: drop-shadow(0px 0px 0.7em rgba(255, 255, 255, 0.655));
  border-radius: 3em;
}

.timeline-time{
  font-weight: 600;
  font-size: 2.4em;
  margin-inline: 2rem;
}

.timeline-story{
  padding-inline: 1em;
}

.timeline-timeport{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-story{
  max-width: 45em;
}
</style>